import { HotelsFlexModuleResult } from "typings/microserviceModels/hotels-flex-module";
import { UitkLink } from "uitk-react-link";
import { TrackedLink } from "components/utility/analytics/TrackedLink";
import * as React from "react";
import { LocalizedComponentProps, LocalizedText } from "bernie-l10n";

interface SeeAllContentLinkProps extends LocalizedComponentProps {
  model: HotelsFlexModuleResult;
  isAffinityFiltersSeeMoreLinkExperimentEnabled: boolean;
  affinityDescription: string;
}

/**
 * Link that will bring the user to a list of all hotels at once instead of top 10
 * @param props
 */
export const SeeAllContentLink = (props: SeeAllContentLinkProps) => {
  const { model, isAffinityFiltersSeeMoreLinkExperimentEnabled, affinityDescription } = props;
  const seeAllLink = model.seeAllLink;

  if (!seeAllLink) {
    return null;
  }
  if (
    model.showMoreStrategy &&
    model.showMoreStrategy !== "top_link" &&
    model.showMoreStrategy !== "button"
  ) {
    return null;
  }

  let seeAllMessage;
  let seeAllParams;

  if (
    isAffinityFiltersSeeMoreLinkExperimentEnabled &&
    affinityDescription !== null &&
    affinityDescription !== ""
  ) {
    seeAllMessage = "hotels.affinity.seeMoreProperties";
    seeAllParams = [affinityDescription, model.locationName];
  } else {
    seeAllMessage = "hotels.seeAllAvailableProperties";
    seeAllParams = [model.locationName];
  }

  return (
    <div className="see-all-hotels" data-testid="see-all-content-link">
      <UitkLink>
        <TrackedLink
          moduleName={model.name}
          href={seeAllLink}
          rfrr={model.seeAllType}
          linkName={seeAllLink}
          rel="nofollow"
        >
          <LocalizedText message={seeAllMessage} data={seeAllParams} />
        </TrackedLink>
      </UitkLink>
    </div>
  );
};
